import React from 'react';

import { Link } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Translate, NotificationBanner } from '@hydra/common/components';

import { sendEvent } from '@hydra/utils/gtm';

const useStyles = makeStyles(theme => ({
  message: {
    padding: 0
  },
  ctaLink: {
    cursor: 'pointer',
    fontWeight: theme.typography.fontWeightSemibold
  },
  messageWrapper: {
    fontSize: theme.typography.fontSizeMedium
  },
  text: {
    marginRight: theme.spacing(0.75)
  }
}));

interface TrialDaysLeftCtaProps {
  days: number
  upgradeDetails?: { type: string, appId: string } | null
  upgradeLink?: string | null
  componentType: 'div' | 'span'
}

export default function TrialDaysLeftCta ({
  days,
  upgradeDetails,
  upgradeLink,
  componentType
}: TrialDaysLeftCtaProps) {
  const classes = useStyles();
  const sendEventOnClick = () => {
    sendEvent('free-trial-upgrade-btn');
  };
  const onClick = (e: any) => {
    e.preventDefault();
    if (window && (window as any)._dAPI && (window as any)._dAPI.upgrade && upgradeDetails) {
      sendEventOnClick();
      (window as any)._dAPI.upgrade(upgradeDetails);
    }
  };

  return (
    <NotificationBanner
      classes={{ message: classes.message }}
      variant='outlined'
      severity={days <= 1 ? 'error' : days <= 3 ? 'warning' : 'info'}
      description={
        <div className={classes.messageWrapper}>
          <Translate
            className={classes.text}
            component={componentType}
            content={days === 1 ? 'free_trial_ends_in_day' : 'free_trial_ends_in_days'}
            with={{ days }}
          />
          {
            upgradeLink
              ? (
                <Link
                  onClick={sendEventOnClick}
                  className={classes.ctaLink}
                  target='_blank'
                  rel='nofollow noopener noreferrer'
                  href={upgradeLink}
                >
                  <Translate content='free_trial_ends_cta' />
                </Link>
                )
              : (
                <Link onClick={onClick} className={classes.ctaLink}>
                  <Translate content='free_trial_ends_cta' />
                </Link>
                )
          }
        </div>
      }
    />
  );
}
